module.exports = __webpack_public_path__ + "img/logo.c3e0ba47.png";